import React from 'react';
import { AiOutlineArrowRight } from 'react-icons/ai';
import style from '../HeroSection.module.css';

const HeaderContent = () => {
    return (
        <div className={style.headerContent}>
            <h2 className={style.headerContentHeading}>
                Creative way of investing in financial assets and expanding your portfolio
            </h2>          
            <p className={style.headerContentParagraph}>
                Get optimized stock and cryptocurrency portfolios to maximize your returns
                with minimal risk. Get optimized stock and cryptocurrency 
            </p>
            <br/>
            <a href='#mainSection' className="btn btn-primary btn-md">
                <span className="me-1">Get Started</span>
                <AiOutlineArrowRight size={16} color="#39ff14"/>
            </a> 
        </div>
    )
}

export default HeaderContent
